import Logging, { TEvent } from "../../plugin/track";

export const trackDirective = {
	beforeMount(el, binding, vnode) {
		if (binding.value) {
			const event = {
				name: binding.value,
				data: {
					action: "",
					testId: "",
					node: el.tagName.toLowerCase()
				}
			};

			// Check for `data-test-id` attribute
			const testId = el.getAttribute("data-test-id");
			if (testId) {
				event.data.testId = testId;
			}

			el.addEventListener("click", () => {
				event.name = `${binding.value}-clicked`;
				event.data.action = `click`;
				Logging.log(event);
			});
		}
	}
};

export default trackDirective;
